module.exports = __webpack_public_path__ + "img/go-singlepackage-min.26fab580.jpg";